import {
  INewsContentBookmark,
  IVideoContentBookmark,
  IPodcastContentBookmark,
  ITermContentBookmark,
} from '@mais-retorno-front/models/content-bookmark.model';
import { axiosPortalInstance } from '@mais-retorno-front/configs/axios-config';

export const getPostBySlug = async (
  slugs: string[]
): Promise<INewsContentBookmark[]> => {
  if (!slugs || slugs.length <= 0) return;

  try {
    const { data } = await axiosPortalInstance({
      method: 'POST',
      data: {
        query: `
        query noticias {
          noticias(filters: {slug: { in: [${slugs}]}}) {
            data {
              id
              attributes {
                title
                slug
                publishedAt
                excerpt
                path
                chapeu
                thumbnail {
                  data {
                    attributes {
                      name
                      alternativeText
                      url
                    }
                  }
                }
                categories {
                  data {
                    id
                    attributes {
                      title
                      slug
                      path
                    }
                  }
                }
              }
            }
          }
        }
        `,
      },
    });

    return data?.data?.noticias?.data;
  } catch (err) {
    return null;
  }
};

export const getVideoBySlug = async (
  slugs: string[]
): Promise<IVideoContentBookmark[]> => {
  if (!slugs || slugs.length <= 0) return;

  try {
    const { data } = await axiosPortalInstance({
      method: 'POST',
      data: {
        query: `
          query videos {
            videos(filters: {slug: { in: [${slugs}]}}) {
              data {
                id
                attributes {
                  title
                  slug
                  video_id
                  path
                  excerpt
                  publishedAt
                }
              }
            }
          }
        `,
      },
    });

    return data.data.videos.data;
  } catch (err) {
    return null;
  }
};

export const getPodcastBySlug = async (
  slugs: string[]
): Promise<IPodcastContentBookmark[]> => {
  if (!slugs || slugs.length <= 0) return;

  try {
    const { data } = await axiosPortalInstance({
      method: 'POST',
      data: {
        query: `
        query podcasts {
          podcasts(filters: {slug: { in: [${slugs}]}}) {
            data {
              id
              attributes {
                title
                slug
                publishedAt
                content
                updatedAt
                excerpt
                path
                duration
                thumbnail {
                  data {
                    attributes {
                      name
                      alternativeText
                      url
                    }
                  }
                }
              }
            }
          }
        }
        `,
      },
    });

    return data.data.podcasts.data;
  } catch (err) {
    return null;
  }
};

export const getTermBySlug = async (
  slugs: string[]
): Promise<ITermContentBookmark[]> => {
  if (!slugs || slugs.length <= 0) return;

  try {
    const { data } = await axiosPortalInstance({
      method: 'POST',
      data: {
        query: `
          query terms {
            glossarios(filters: {slug: { in: [${slugs}]}}) {
              data {
                id
                attributes {
                  title
                  slug
                  publishedAt
                  content
                }
              }
            }
          }
        `,
      },
    });

    return data.data.glossarios.data;
  } catch (err) {
    return null;
  }
};
